var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component, Fragment } from "react";
import ReactDOM from 'react-dom';
import SpsModalOverlay from "./SpsModalOverlay";
import classnames from "classnames";
import { SpsButton } from '../index.js';

var SpsModalHeader = function (_Component) {
    _inherits(SpsModalHeader, _Component);

    function SpsModalHeader() {
        _classCallCheck(this, SpsModalHeader);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    SpsModalHeader.prototype.render = function render() {
        var _props = this.props,
            header = _props.header,
            className = _props.className;

        var headerClass = classnames("sps-modal__header", className);
        var modalHeader = typeof header === "function" ? header : function () {
            return React.createElement(
                "h6",
                { className: "sps-modal__title" },
                header
            );
        };
        return React.createElement(
            "div",
            { className: headerClass },
            modalHeader()
        );
    };

    return SpsModalHeader;
}(Component);

var SpsModalBody = function (_Component2) {
    _inherits(SpsModalBody, _Component2);

    function SpsModalBody() {
        _classCallCheck(this, SpsModalBody);

        return _possibleConstructorReturn(this, _Component2.apply(this, arguments));
    }

    SpsModalBody.prototype.render = function render() {
        var _props2 = this.props,
            children = _props2.children,
            className = _props2.className;

        var bodyClass = classnames("sps-modal__body", className);
        return React.createElement(
            "div",
            { className: bodyClass },
            children
        );
    };

    return SpsModalBody;
}(Component);

var SpsModalAction = function (_Component3) {
    _inherits(SpsModalAction, _Component3);

    function SpsModalAction() {
        _classCallCheck(this, SpsModalAction);

        return _possibleConstructorReturn(this, _Component3.apply(this, arguments));
    }

    SpsModalAction.prototype.render = function render() {
        var _this4 = this;

        var _props3 = this.props,
            children = _props3.children,
            onClick = _props3.onClick,
            kind = _props3.kind,
            closeModal = _props3.closeModal,
            handleAsync = _props3.handleAsync;

        var onClickFunc = closeModal;
        if (onClick && typeof onClick === 'function') {
            onClickFunc = function onClickFunc() {
                var result = onClick();
                if (result !== undefined) {
                    if (result === false) {} else if (typeof result.then === 'function') {
                        _this4.setState({ spinning: true });
                        _this4.asyncButton = true;
                        handleAsync.turnAsyncOn();
                        result.then(function () {
                            closeModal();
                            handleAsync.turnAsyncOff();
                        });
                    }
                } else {
                    closeModal();
                }
            };
        }
        return React.createElement(SpsButton, {
            preset: kind,
            message: children,
            onClick: onClickFunc,
            disabled: this.asyncButton ? false : handleAsync.isAsyncOn,
            spinning: this.asyncButton ? handleAsync.isAsyncOn : false
        });
    };

    return SpsModalAction;
}(Component);

var SpsModalFooter = function (_Component4) {
    _inherits(SpsModalFooter, _Component4);

    function SpsModalFooter() {
        _classCallCheck(this, SpsModalFooter);

        return _possibleConstructorReturn(this, _Component4.apply(this, arguments));
    }

    SpsModalFooter.prototype.render = function render() {
        var _props4 = this.props,
            children = _props4.children,
            className = _props4.className,
            handleAsync = _props4.handleAsync,
            closeModal = _props4.closeModal;

        var footerClass = classnames("sps-modal__footer", className);
        return React.createElement(
            "div",
            { className: footerClass },
            React.Children.count(children) ? React.Children.map(children, function (child, i) {
                if (i === children.length - 1) {
                    return React.cloneElement(child, {
                        closeModal: closeModal,
                        handleAsync: handleAsync,
                        kind: 'key'
                    });
                } else {
                    return React.cloneElement(child, {
                        closeModal: closeModal,
                        handleAsync: handleAsync
                    });
                }
            }) : React.createElement(SpsButton, {
                preset: "key",
                message: 'OK',
                onClick: closeModal
            })
        );
    };

    return SpsModalFooter;
}(Component);

export var SpsModal = function (_Component5) {
    _inherits(SpsModal, _Component5);

    function SpsModal(props) {
        _classCallCheck(this, SpsModal);

        var _this6 = _possibleConstructorReturn(this, _Component5.call(this, props));

        _this6.open = function () {
            document.addEventListener('keydown', _this6.onKeyDown);
            document.body.classList.add('modal-open');
            _this6.setState({ visible: true });
            if (typeof _this6.props.onOpen === "function") _this6.props.onOpen();
        };

        _this6.close = function () {
            document.removeEventListener('keydown', _this6.onKeyDown);
            document.body.classList.remove('modal-open');
            _this6.setState({ visible: false });
            if (typeof _this6.props.onClose === "function") _this6.props.onClose();
        };

        _this6.turnOnAsyncMode = function () {
            _this6.setState({
                isAsyncOn: true
            });
        };

        _this6.turnOffAsyncMode = function () {
            _this6.setState({
                isAsyncOn: false
            });
        };

        _this6.setFocus = function (e) {
            if (_this6.element) {
                var focusable = _this6.element.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[contenteditable], [tabindex]:not([tabindex="-1"])');
                if (focusable.length) {
                    _this6.firstFocusable = focusable[0];
                    _this6.lastFocusable = focusable[focusable.length - 1];
                    if (e && e.target === _this6.lastFocusable) {
                        _this6.firstFocusable.focus();
                    } else {
                        _this6.lastFocusable.focus();
                    }
                }
            }
        };

        _this6.closeable = function () {
            if (!_this6.props.actionRequired && !_this6.state.isAsyncOn) {
                return _this6.close;
            } else {
                return function () {};
            }
        };

        _this6.onKeyDown = function (e) {
            switch (e.key) {
                case "Escape":
                    _this6.closeable()();
                    break;
                case "Tab":
                    if (e.target === _this6.lastFocusable) {
                        _this6.setFocus(e);
                        e.preventDefault();
                    }
                    break;
            }
        };

        _this6.renderModalTemplate = function () {
            var handleAsync = {
                turnAsyncOn: _this6.turnOnAsyncMode,
                turnAsyncOff: _this6.turnOffAsyncMode,
                isAsyncOn: _this6.state.isAsyncOn
            };
            var modalTypes = {
                default: "sps-modal--default",
                success: "sps-modal--success",
                delete: "sps-modal--delete",
                key: "sps-modal--key",
                info: "sps-modal--info",
                tip: "sps-modal--tip",
                warning: "sps-modal--warning"
            };

            var modalSizes = {
                small: "sps-modal__dialog--small",
                large: "sps-modal__dialog--large"
            };

            var show = {
                display: 'block',
                pointerEvents: 'none',
                paddingRight: '17px'
            };

            var hide = {
                display: 'none'
            };

            var _this6$props = _this6.props,
                id = _this6$props.id,
                size = _this6$props.size,
                visible = _this6$props.visible,
                backdrop = _this6$props.backdrop,
                onClose = _this6$props.onClose,
                onOpen = _this6$props.onOpen,
                header = _this6$props.header,
                footer = _this6$props.footer,
                kind = _this6$props.kind,
                children = _this6$props.children,
                className = _this6$props.className,
                actionRequired = _this6$props.actionRequired,
                rest = _objectWithoutProperties(_this6$props, ["id", "size", "visible", "backdrop", "onClose", "onOpen", "header", "footer", "kind", "children", "className", "actionRequired"]);

            var modalClass = void 0,
                modalDialogClass = void 0;

            if (!kind) throw new Error("SpsModal: kind is a required field");

            if (!id) throw new Error("SpsModal: id is a required field");

            if (!modalTypes[kind]) throw new Error("SpsModal: invalid kind");

            modalClass = classnames("sps-modal", className, modalTypes[kind]);
            modalDialogClass = classnames("sps-modal__dialog", modalSizes[size]);
            return React.createElement(
                Fragment,
                null,
                React.createElement(
                    "div",
                    _extends({ className: modalClass }, rest, { style: _this6.state.visible ? show : hide, role: "dialog", tabIndex: "-1", onKeyDown: _this6.onKeyDown, ref: function ref(el) {
                            return _this6.element = el;
                        } }),
                    React.createElement(
                        "div",
                        { className: modalDialogClass, role: "document" },
                        React.createElement(
                            "div",
                            { className: "sps-modal__content" },
                            header ? React.createElement(SpsModalHeader, { header: header }) : null,
                            React.Children.map(children, function (child) {
                                return React.cloneElement(child, { closeModal: _this6.close, handleAsync: handleAsync });
                            })
                        )
                    )
                ),
                React.createElement(SpsModalOverlay, { id: 'modal_overlay_' + id, backdrop: backdrop, onOverlayClick: _this6.closeable() })
            );
        };

        _this6.state = {
            visible: false,
            isAsyncOn: false
        };
        return _this6;
    }

    SpsModal.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        // Focus only needs to be set once when the modal is being opened
        if (this.state.visible && !prevState.visible) this.setFocus();
        // We need to remove the modal-open class if visibility is being set in parent component
        else if (!this.state.visible && prevState.visible) document.body.classList.remove('modal-open');
    };

    SpsModal.prototype.componentWillUnmount = function componentWillUnmount() {
        // We need to remove the modal-open class when the component unmounts to ensure overflow: hidden style is removed from body
        document.body.classList.remove('modal-open');
    };

    SpsModal.prototype.render = function render() {
        return ReactDOM.createPortal(React.createElement(
            Fragment,
            null,
            this.state.visible ? this.renderModalTemplate() : null
        ), document.body);
    };

    return SpsModal;
}(Component);

export default SpsModal;
export { SpsModalBody, SpsModalFooter, SpsModalAction };